/** MEMORY_FAREWELL — winter Xingtang: the father's decision, 琼, 赵三, 赵呈博 arrives. */
import type { DialogueData } from '@/core/types/contracts';
import { SPEAKER } from '../actors';
import { letter, linear, narr, say } from './util';

export const FAREWELL_DIALOGUES: DialogueData[] = [
  linear('prologue-farewell-intro', [
    narr('星塘。屋里，婆婆正跟父母说着话。'),
    narr('塘面已经结了冰。'),
  ]),
  linear('prologue-farewell-father', [
    say(SPEAKER.father, '子潮，过来。'),
    // The father's speech is kept as ONE verbatim line (STORY_ADAPTATION P5 must-keep).
    say(SPEAKER.father, '婆婆说你的病需要新鲜的南陆旱龟蛋。家里，长阳城都不会有你想要的东西，你去南陆吧。你也大了，自己出去闯闯。家里还需要我来照顾。我听说长阳城经验最丰富的长者赵呈博也要去南陆，你跟他一起去吧！'),
    say(SPEAKER.jiang, '……好。我明天就去长阳城找赵长者。'),
  ]),
  {
    id: 'prologue-farewell-qiong',
    start: 'q0',
    nodes: [
      { id: 'q0', speaker: SPEAKER.qiong, text: '子潮……你真的要去南陆？', condition: { notMark: 'talked:qiong' }, elseNext: 'again', next: 'q1' },
      { id: 'q1', speaker: SPEAKER.jiang, text: '婆婆说，那里有我的答案。', next: 'q2' },
      { id: 'q2', speaker: SPEAKER.qiong, text: '……', setMark: 'talked:qiong' },
      { id: 'again', speaker: SPEAKER.qiong, text: '……早点回来。' },
    ],
  },
  linear('prologue-farewell-loom', [
    narr('琼的织机。她织布的手艺，所有人都羡慕。'),
  ]),
  {
    id: 'prologue-farewell-zhaosan',
    start: 'z0',
    nodes: [
      { id: 'z0', speaker: SPEAKER.zhaosan, text: '子潮，那山你可别再往上爬了。三重就够吓人的了。', condition: { notMark: 'talked:zhaosan' }, elseNext: 'again', next: 'z1' },
      { id: 'z1', speaker: SPEAKER.jiang, text: '我还想爬到四重五重呢。', next: 'z2' },
      { id: 'z2', speaker: SPEAKER.zhaosan, text: '别别别……', setMark: 'talked:zhaosan' },
      { id: 'again', speaker: SPEAKER.zhaosan, text: '……南陆那么远，你可小心点。' },
    ],
  },
  linear('prologue-farewell-mountain', [
    narr('旁边的那座山。我是村子里第一个能爬到三重的。'),
  ]),
  linear('prologue-farewell-well', [
    narr('村里的井。婆婆总是拄着说不清颜色的棍子来这里打水，然后拧着回家。'),
  ]),
  linear('prologue-farewell-ice', [
    narr('星塘的水面结了冰。'),
  ]),
  linear('prologue-farewell-zhao-arrives', [
    letter('我本来准备到长阳城去找赵呈博的，第二天他居然自己跑来找我了。'),
    say(SPEAKER.zhao, '江子潮？我是赵呈博。听说你要去南陆。'),
    say(SPEAKER.jiang, '赵……赵长者！我正要去长阳城找您。'),
    say(SPEAKER.jiang, '唉，看来我的病真的是很紧急了。', { emotion: 'thought' }),
    say(SPEAKER.zhao, '收拾一下，我们上路。'),
  ]),
  linear('prologue-farewell-depart', [
    letter('我们就一起上路了。'),
    letter('琼，刚开始你还哭呢。'),
    letter('不过我开始也挺兴奋，后来就觉得想你了。'),
  ]),
];
